import angular from "angular";
import './Preview.scss';

let CmsPagesPreview = angular.module('cms.pages.preview', [])
  .component('cmsPagesPreview', {
      bindings: {
        page: '=',
        prePreview: '<',
        pending: '<'
      },
      template: require('./preview.html'),
      controller: function ($uibModal, ExportPageTemplateService) {

        this.preview = () => {

          this.prePreview(false,false).then((response) => {

            this.page = response;

            $uibModal.open({
              template: require('./PreviewModal.html'),
              size: 'lg',
              controllerAs: '$ctrl',
              controller: function (url, $sce) {
                this.url = $sce.trustAsResourceUrl(url);
                this.loading = true;
                this.shownSize = 'desktop';

                this.onLoaded = (event) => {
                  this.loading = false;
                };

                this.setMobile = () => {
                  this.shownSize = 'mobile';
                };

                this.setTablet = () => {
                    this.shownSize = 'tablet';
                };

                this.setDesktop = () => {
                  this.shownSize = 'desktop';
                };

              },
              windowClass : "pagePreview",
              resolve: {
                url: () => {
                  return this.getTemplateUrl(response.slug);
                }
              },
            }).result.then(() => {}, (res) => {
            });

          }).catch((e) => {
              console.log(e);
          })
        };

        this.getTemplateUrl = (slug) => {
            return ExportPageTemplateService.getUrl(slug);
        };
      }
    }
  );

export default CmsPagesPreview.name;


// WEBPACK FOOTER //
// ./src/cmsPages/Pages/Preview/Preview.js